<template>
    <div class="container">
        <h1 style="font-size: 60px;">{{ $t("contactUs") }}</h1>

        <form class="contact-form" @submit.prevent="submitmessage" @keydown="form.onKeydown($event)">
            <div class="row g-3 mb-3">
                <div class="col-md-6">
                    <input type="text" class="form-control" :placeholder="$t('name')" v-model="form.name" required>
                </div>
                <div class="col-md-6">
                    <input type="text" class="form-control" :placeholder="$t('Email')" v-model="form.email" required>
                </div>
            </div>

            <div class="mb-3">
                <input type="text" class="form-control" :placeholder="$t('phone')" v-model="form.phone" required>
            </div>
            <div class="mb-3">
                <textarea class="form-control" rows="5"
                    style="background-color: transparent;     border: 1px solid #888;;" :placeholder="$t('message')"
                    v-model="form.message" required></textarea>
            </div>
            <br>
            <div class="form-actions full-width">
                <button type="submit" :disabled="form.busy">{{ $t("SendMessage") }}</button>
            </div>
            <div style="position: fixed; width: 500px; bottom: 10px; left: 10px">
            <AlertSuccess :form="form" :message="$t('Message1')" />
            <AlertErrors :form="form" :message="$t('Message0')" />
          </div>
        </form>
    </div>
</template>
<script>
import Form from "vform";
import { AlertErrors, AlertSuccess } from "vform/src/components/bootstrap5";

export default {
    components: {
        AlertErrors,
        AlertSuccess
    },
    data: function () {
        return {
            loading: false,
            DBitems: null,

            form: new Form({
                name: null,
                email: null,
                message: null,
                phone: null
            }),
        };
    },
    created() {
this.$store.state.showHeader=true;
    this.$store.state.showFooter=true;
    },
    methods: {
        async submitmessage() {
            const response = await this.form
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/send_message",
                    {
                        message: this.form.message,
                        name: this.form.name,
                        email: this.form.email
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    if (response.data.code == "1") {
                        this.form.message = "";
                        this.form.name = "";
                        this.form.email = "";
                        console.log(response.data.message);
                    }
                    if (response.data.error) {
                        this.errorMessage = response.data.message;
                    }
                });
        },
    }
};
</script>